module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6wfHrpqsKBL2ddCvnfXpG1-743920c750e19df51bfc021c806739a8.jpg";